import {
  login,
  logout,
  getInfo
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken,
  getRole,
  setRole,
  removeRole
} from '@/utils/auth'
import router, {
  resetRouter
} from '@/router'
import {
  encrypt
} from '@/utils/sm2'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    buttons: [],
    roles: [],
    role: [],
    menu: [],
    roleId: getRole(),
    currentInfo: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_BUTTONS: (state, buttons) => {
      state.buttons = buttons
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_MENU: (state, menu) => {
      state.menu = menu
    },
    SET_ROLEID: (state, roleId) => {
      state.roleId = roleId
    },
    SET_CURRENTINFO: (state, currentInfo) => {
      state.currentInfo = currentInfo
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      const username = userInfo.username.trim()
      var psw = encrypt(userInfo.password)
      return new Promise((resolve, reject) => {
        login(username, psw).then(response => {
          // debugger
          // const data = response.data
          setToken(response.token)
          commit('SET_TOKEN', response.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      // console.log(1.5)
      // state.roleId = getRole()
      return new Promise((resolve, reject) => {
        getInfo(state.roleId).then(response => {
          // console.log(state.roleId)
          // debugger
          // console.log(response.token)
          // const res = response.userInfoList.filter(item => item.rolesname)
          // const roles = res.map(item => {
          //   return item.rolesname
          // })
          setToken(response.token)
          console.log( ' response.userInfoList ===>',response.userInfoList )
          const roles = response.userInfoList // 下拉框角色存储

          const resp = response.currentUserInfo
          const role = resp.rolesname // 当前角色存储
          const roleId = resp.id // 当前角色id

          const menu = response.menuTree
          // console.log(roles)
          // const data = response.data
          if (role && role.length > 0) { // 验证返回的roles是否是一个非空数组
            setRole(roleId)
            commit('SET_ROLEID', roleId)
            commit('SET_ROLE', role)
            commit('SET_ROLES', roles)
            commit('SET_MENU', menu)
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('getInfo: roles must be a non-null array !')
          }

          // const buttonAuthList = []
          // data.permissionValueList.forEach(button => {
          //   buttonAuthList.push(button)
          // })
          commit('SET_CURRENTINFO', resp)
          commit('SET_TOKEN', response.token)
          commit('SET_NAME', response.name)
          // commit('SET_AVATAR', data.avatar)
          // commit('SET_BUTTONS', buttonAuthList)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          // debugger
          commit('SET_TOKEN', '') // 清空前端vuex中存储的数据
          commit('SET_ROLEID', '')
          commit('SET_ROLE', []) // 清空前端vuex中存储的数据
          commit('SET_ROLES', []) // 清空前端vuex中存储的数据
          commit('SET_BUTTONS', [])
          removeRole()
          removeToken() // 清空cookie
          resetRouter()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        // debugger
        commit('SET_TOKEN', '')
        commit('SET_ROLEID', '')
        commit('SET_ROLE', []) // 清空前端vuex中存储的数据
        commit('SET_ROLES', []) // 清空前端vuex中存储的数据
        commit('SET_BUTTONS', [])
        removeRole()
        removeToken()
        resolve()
      })
    },

    // dynamically modify permissions
    async changeRoles({
      dispatch
    }) {
      await dispatch('GetInfo')
      resetRouter()
      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes')
      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
    },

    // 切换角色
    role({
      commit
    }) {
      return new Promise(resolve => {
        // debugger
        commit('SET_ROLE', []) // 清空前端vuex中存储的数据
        resolve()
      })
    }
  }
}

export default user